import { Route, Routes } from 'react-router-dom'
import Ben from 'subdomains/Ben'

export const benRoutes = {
  subdomain: 'ben',
  routes: () => (
    <Routes>
      <Route path='/' element={<Ben />} />
    </Routes>
  ),
}
